import is from 'is_js';
import { buildUrl } from 'domain/Api';
import { ApiCall } from 'omni-common-ui';

const buildUserUrl = (userId) => buildUrl(`/users/${userId}`);

export function getLoginUserId(state) {
  return state.get('singleSignOn').get('user') &&
    state.get('singleSignOn').get('user').get('profile').sub;
}

function getLoginUserName(state) {
  return state.get('singleSignOn').get('user') &&
    state.get('singleSignOn').get('user').get('profile').name;
}

export function getCurrentUserId(state) {
  return (state.get('singleSignOn').get('user') &&
    state.get('singleSignOn').get('user').get('profile').impersonated_user_id) ||
    getLoginUserId(state);
}

export function getCurrentUserName(state) {
  return (state.get('singleSignOn').get('user') &&
    state.get('singleSignOn').get('user').get('profile').impersonated_user_name) ||
    getLoginUserName(state);
}

export function getUserByUserId(state, userId, notFoundFn) {
  const user = state.get('rootReducer').get('user').get(`${userId}`);
  if (is.undefined(user)) {
    is.function(notFoundFn) && notFoundFn(userId);
    return undefined;
  }
  return user;
}

export function isLoadingUser(state, userId) {
  const callState = ApiCall.find(state, { method: 'GET', url: buildUserUrl(userId) });
  return ApiCall.State.isValue(callState) && ApiCall.State.isLoading(callState);
}



// WEBPACK FOOTER //
// ./data/Users/accessors.js